import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaRoad, FaSeedling, FaCity, FaWater, FaMountain, FaHome, FaBuilding, FaTimes, FaExternalLinkAlt, FaHandshake, FaClock, FaMapMarkerAlt, FaDollarSign, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const projects = [
  {
    id: 1,
    titleAr: 'مشروع محجر الحجر الجيري - جبل المقطم',
    titleEn: 'Limestone Quarry Project - Mokattam Mountain',
    descriptionAr: 'مشروع استخراج وتجهيز الحجر الجيري عالي الجودة من جبل المقطم، مع تطبيق أحدث تقنيات التعدين المستدامة',
    descriptionEn: 'High-quality limestone extraction and processing project from Mokattam Mountain, applying the latest sustainable mining technologies',
    images: [
      'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1578662996442-48f60103fc96?auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1545454675-3531b543be5d?auto=format&fit=crop&w=800&q=80'
    ],
    icon: FaMountain,
    detailsAr: 'تم تطوير محجر متكامل في جبل المقطم باستخدام أحدث تقنيات التعدين المستدامة. المشروع يشمل استخراج وتجهيز الحجر الجيري عالي الجودة مع الحفاظ على البيئة المحلية. تم تركيب معدات حديثة لضمان أعلى معايير الجودة والسلامة.',
    detailsEn: 'An integrated quarry was developed in Mokattam Mountain using the latest sustainable mining technologies. The project includes extraction and processing of high-quality limestone while preserving the local environment. Modern equipment was installed to ensure the highest standards of quality and safety.',
    stats: {
      client: 'شركة مكة البركة',
      duration: '36 شهر',
      location: 'جبل المقطم، القاهرة',
      value: '500 مليون جنيه'
    }
  },
  {
    id: 2,
    titleAr: 'مشروع تطوير طريق القاهرة - السويس',
    titleEn: 'Cairo - Suez Road Development Project',
    descriptionAr: 'توسعة وتطوير الطريق الحيوي الذي يربط القاهرة بمدينة السويس، مع تنفيذ أعمال رصف حديثة وتحسينات مرورية',
    descriptionEn: 'Expansion and development of the vital road connecting Cairo to Suez city, with modern paving works and traffic improvements',
    images: [
      'https://images.unsplash.com/photo-1545454675-3531b543be5d?auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1578662996442-48f60103fc96?auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=800&q=80'
    ],
    icon: FaRoad,
    detailsAr: 'تم تنفيذ هذا المشروع الحيوي على مراحل متعددة، حيث شمل توسعة الطريق من مسارين إلى أربعة مسارات، مع إضافة جسور علوية وأنفاق لتحسين تدفق المرور. تم استخدام أحدث تقنيات الرصف والإنارة الذكية لضمان أعلى معايير الجودة والسلامة.',
    detailsEn: 'This vital project was implemented in multiple phases, including road expansion from two lanes to four lanes, with the addition of overpasses and tunnels to improve traffic flow. The latest paving technologies and smart lighting were used to ensure the highest standards of quality and safety.',
    stats: {
      client: 'وزارة النقل',
      duration: '24 شهر',
      location: 'القاهرة - السويس',
      value: '800 مليون جنيه'
    }
  },
  {
    id: 3,
    titleAr: 'مشروع محجر الجرانيت - أسوان',
    titleEn: 'Granite Quarry Project - Aswan',
    descriptionAr: 'استخراج وتجهيز الجرانيت المصري عالي الجودة من محاجر أسوان الشهيرة، مع تطبيق معايير السلامة العالمية',
    descriptionEn: 'Extraction and processing of high-quality Egyptian granite from the famous Aswan quarries, applying international safety standards',
    images: [
      'https://images.unsplash.com/photo-1578662996442-48f60103fc96?auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1545454675-3531b543be5d?auto=format&fit=crop&w=800&q=80'
    ],
    icon: FaMountain,
    detailsAr: 'تم تطوير محجر متكامل في أسوان لاستخراج الجرانيت المصري الشهير عالمياً. المشروع يشمل مرافق معالجة حديثة ومعدات متطورة لضمان جودة المنتج النهائي. تم تطبيق جميع معايير السلامة البيئية.',
    detailsEn: 'An integrated quarry was developed in Aswan to extract the world-famous Egyptian granite. The project includes modern processing facilities and advanced equipment to ensure the quality of the final product. All environmental safety standards were applied.',
    stats: {
      client: 'شركة مكة البركة',
      duration: '30 شهر',
      location: 'أسوان، مصر',
      value: '400 مليون جنيه'
    }
  },
  {
    id: 4,
    titleAr: 'مشروع مجمع سكني مكة البركة',
    titleEn: 'Mecca El Baraka Residential Complex',
    descriptionAr: 'مجمع سكني متكامل يحتوي على 500 وحدة سكنية مع مرافق ترفيهية وتجارية متكاملة',
    descriptionEn: 'Integrated residential complex containing 500 housing units with integrated recreational and commercial facilities',
    images: [
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1578662996442-48f60103fc96?auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=800&q=80'
    ],
    icon: FaBuilding,
    detailsAr: 'تم إنشاء مجمع سكني متكامل في القاهرة الجديدة يحتوي على 500 وحدة سكنية متنوعة. المشروع يشمل مرافق ترفيهية متكاملة ومراكز تجارية ومساحات خضراء. تم تطبيق أحدث تقنيات البناء المستدام.',
    detailsEn: 'An integrated residential complex was built in New Cairo containing 500 diverse housing units. The project includes integrated recreational facilities, commercial centers, and green spaces. The latest sustainable construction technologies were applied.',
    stats: {
      client: 'شركة مكة البركة',
      duration: '42 شهر',
      location: 'القاهرة الجديدة',
      value: '1.2 مليار جنيه'
    }
  },
  {
    id: 5,
    titleAr: 'مشروع محجر الرخام - المنيا',
    titleEn: 'Marble Quarry Project - Minya',
    descriptionAr: 'استخراج وتجهيز الرخام المصري عالي الجودة من محاجر المنيا، مع تطبيق تقنيات التعدين الحديثة',
    descriptionEn: 'Extraction and processing of high-quality Egyptian marble from Minya quarries, applying modern mining technologies',
    images: [
      'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1578662996442-48f60103fc96?auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1545454675-3531b543be5d?auto=format&fit=crop&w=800&q=80'
    ],
    icon: FaMountain,
    detailsAr: 'تم تطوير محجر رخام متكامل في المنيا لاستخراج الرخام المصري عالي الجودة. المشروع يشمل مرافق معالجة حديثة ومعدات متطورة لضمان جودة المنتج النهائي. تم تطبيق جميع معايير السلامة البيئية.',
    detailsEn: 'An integrated marble quarry was developed in Minya to extract high-quality Egyptian marble. The project includes modern processing facilities and advanced equipment to ensure the quality of the final product. All environmental safety standards were applied.',
    stats: {
      client: 'شركة مكة البركة',
      duration: '28 شهر',
      location: 'المنيا، مصر',
      value: '300 مليون جنيه'
    }
  },
  {
    id: 6,
    titleAr: 'مشروع جسر النيل - الإسكندرية',
    titleEn: 'Nile Bridge Project - Alexandria',
    descriptionAr: 'إنشاء جسر حديث يربط ضفتي النيل في الإسكندرية، مع تطبيق أحدث تقنيات البناء والتصميم',
    descriptionEn: 'Construction of a modern bridge connecting the two banks of the Nile in Alexandria, applying the latest construction and design technologies',
    images: [
      'https://images.unsplash.com/photo-1578662996442-48f60103fc96?auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1545454675-3531b543be5d?auto=format&fit=crop&w=800&q=80'
    ],
    icon: FaRoad,
    detailsAr: 'تم إنشاء جسر حديث بطول 2.5 كم يربط ضفتي النيل في الإسكندرية. الجسر مصمم بأحدث التقنيات الهندسية ويحتوي على 6 مسارات للمركبات ومسارين للمشاة. تم تطبيق معايير السلامة العالمية.',
    detailsEn: 'A modern bridge with a length of 2.5 km was built connecting the two banks of the Nile in Alexandria. The bridge is designed with the latest engineering technologies and contains 6 vehicle lanes and 2 pedestrian lanes. International safety standards were applied.',
    stats: {
      client: 'محافظة الإسكندرية',
      duration: '36 شهر',
      location: 'الإسكندرية، مصر',
      value: '600 مليون جنيه'
    }
  },
  {
    id: 5,
    titleAr: 'محطة معالجة مياه الصرف الصحي',
    titleEn: 'Sewage Treatment Plant',
    descriptionAr: 'إنشاء محطة معالجة مياه صرف صحي متطورة باستخدام أحدث التقنيات لضمان جودة المياه المعالجة وحماية البيئة.',
    descriptionEn: 'Construction of an advanced sewage treatment plant using the latest technologies to ensure treated water quality and environmental protection.',
    images: [
      'https://images.unsplash.com/photo-1578662996442-48f60103fc96?auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=800&q=80'
    ],
    icon: FaWater,
    detailsAr: 'تم بناء محطة معالجة متطورة بسعة 50,000 متر مكعب يومياً، تستخدم أحدث تقنيات المعالجة البيولوجية والكيميائية. المحطة مزودة بنظام مراقبة ذكي ومرافق تخزين آمنة.',
    detailsEn: 'An advanced treatment plant with a capacity of 50,000 cubic meters per day was built, using the latest biological and chemical treatment technologies. The plant is equipped with a smart monitoring system and secure storage facilities.',
    stats: {
      client: 'وزارة البيئة',
      duration: '30 شهر',
      location: 'منطقة السادات',
      value: '250 مليون جنيه'
    }
  },
  {
    id: 6,
    titleAr: 'تطوير محجر الحجر الجيري بمنطقة بني سويف',
    titleEn: 'Development of Limestone Quarry in Beni Suef Area',
    descriptionAr: 'تطوير وإدارة محجر الحجر الجيري باستخدام معدات حديثة لضمان توفير المواد الخام لمشروعات البناء والبنية التحتية.',
    descriptionEn: 'Development and management of limestone quarry using modern equipment to ensure provision of raw materials for construction and infrastructure projects.',
    images: [
      'https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1578662996442-48f60103fc96?auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=800&q=80'
    ],
    icon: FaMountain,
    detailsAr: 'تم تطوير المحجر على مساحة 100 فدان، مع تركيب معدات استخراج وتكسير حديثة. تم إنشاء نظام نقل آلي وخطوط إنتاج متطورة لضمان جودة المنتج.',
    detailsEn: 'The quarry was developed on 100 acres, with installation of modern extraction and crushing equipment. An automated transport system and advanced production lines were established to ensure product quality.',
    stats: {
      client: 'شركة أسمنت بني سويف',
      duration: '18 شهر',
      location: 'بني سويف',
      value: '120 مليون جنيه'
    }
  },
  {
    id: 7,
    titleAr: 'مشروع الإسكان الاجتماعي بمدينة بدر',
    titleEn: 'Social Housing Project in Badr City',
    descriptionAr: 'تنفيذ وحدات سكنية حديثة ضمن مشروع الإسكان الاجتماعي، مع مرافق متكاملة تلبي احتياجات الأسر المصرية.',
    descriptionEn: 'Implementation of modern housing units within the social housing project, with integrated facilities that meet the needs of Egyptian families.',
    images: [
      'https://images.unsplash.com/photo-1507089947368-19c1da9775ae?auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1578662996442-48f60103fc96?auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=800&q=80'
    ],
    icon: FaHome,
    detailsAr: 'تم بناء 1000 وحدة سكنية متنوعة الأحجام، مع مرافق اجتماعية متكاملة تشمل مدارس ومستشفى ومراكز تجارية. تم استخدام مواد بناء عالية الجودة وتقنيات عزل حديثة.',
    detailsEn: '1,000 housing units of various sizes were built, with integrated social facilities including schools, a hospital, and commercial centers. High-quality building materials and modern insulation technologies were used.',
    stats: {
      client: 'وزارة الإسكان',
      duration: '42 شهر',
      location: 'مدينة بدر',
      value: '400 مليون جنيه'
    }
  },
  {
    id: 8,
    titleAr: 'إنشاء مجمع خدمي متكامل بمدينة العاشر من رمضان',
    titleEn: 'Construction of Integrated Service Complex in 10th of Ramadan City',
    descriptionAr: 'إنشاء مجمع خدمي يضم مرافق إدارية وتجارية وصحية، يخدم سكان المدينة ويوفر بيئة متكاملة للأعمال والخدمات.',
    descriptionEn: 'Construction of a service complex including administrative, commercial, and health facilities, serving the city\'s residents and providing an integrated environment for business and services.',
    images: [
      'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1578662996442-48f60103fc96?auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=800&q=80'
    ],
    icon: FaBuilding,
    detailsAr: 'تم بناء مجمع متكامل على مساحة 50,000 متر مربع، يضم مكاتب إدارية ومحلات تجارية ومطاعم ومركز طبي. المجمع مزود بموقف سيارات متعدد الطوابق وحدائق خارجية.',
    detailsEn: 'An integrated complex was built on 50,000 square meters, including administrative offices, shops, restaurants, and a medical center. The complex is equipped with a multi-story parking garage and outdoor gardens.',
    stats: {
      client: 'هيئة المجتمعات العمرانية',
      duration: '24 شهر',
      location: 'العاشر من رمضان',
      value: '180 مليون جنيه'
    }
  },
];

// Project Modal Component
const ProjectModal: React.FC<{
  project: typeof projects[0];
  isOpen: boolean;
  onClose: () => void;
  language: 'ar' | 'en';
}> = ({ project, isOpen, onClose, language }) => {
  const isRTL = language === 'ar';
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % project.images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + project.images.length) % project.images.length);
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0, y: 50 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.8, opacity: 0, y: 50 }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            className="relative bg-white rounded-2xl max-w-5xl w-full max-h-[90vh] overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={onClose}
              className="absolute top-4 right-4 z-20 bg-white/90 hover:bg-white rounded-full p-2 shadow-lg transition-all duration-300 hover:scale-110"
            >
              <FaTimes className="w-5 h-5 text-gray-600" />
            </button>

            {/* Project Image Gallery */}
            <div className="relative h-64 md:h-80 overflow-hidden">
              <img
                src={project.images[currentImageIndex]}
                alt={`${isRTL ? project.titleAr : project.titleEn} - Image ${currentImageIndex + 1}`}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              
              {/* Navigation Arrows */}
              {project.images.length > 1 && (
                <>
                  <button
                    onClick={prevImage}
                    className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 shadow-lg transition-all duration-300 hover:scale-110 z-10"
                  >
                    <FaChevronLeft className="w-4 h-4 text-gray-700" />
                  </button>
                  <button
                    onClick={nextImage}
                    className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 shadow-lg transition-all duration-300 hover:scale-110 z-10"
                  >
                    <FaChevronRight className="w-4 h-4 text-gray-700" />
                  </button>
                </>
              )}
              
              {/* Image Counter */}
              <div className="absolute bottom-4 right-4 bg-black/70 text-white px-3 py-1 rounded-full text-sm">
                {currentImageIndex + 1} / {project.images.length}
              </div>
              
              {/* Project Icon */}
              <div className="absolute bottom-4 left-4 bg-white/90 rounded-full p-3 shadow">
                <project.icon className="w-8 h-8 text-gold-500" />
              </div>
            </div>

            {/* Project Content */}
            <div className="p-6 md:p-8 overflow-y-auto max-h-[calc(90vh-320px)]">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                {isRTL ? project.titleAr : project.titleEn}
              </h2>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                {isRTL ? project.descriptionAr : project.descriptionEn}
              </p>

              {/* Project Stats */}
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
                <div className="bg-blue-50 rounded-lg p-4 text-center">
                  <div className="flex justify-center mb-2">
                    <FaHandshake className="w-6 h-6 text-blue-600" />
                  </div>
                  <div className="text-sm font-semibold text-blue-600 mb-1">
                    {language === 'ar' ? 'الجهة المانحة' : 'Client'}
                  </div>
                  <div className="text-xs text-gray-600">
                    {isRTL ? project.stats.client : project.stats.client}
                  </div>
                </div>
                <div className="bg-green-50 rounded-lg p-4 text-center">
                  <div className="flex justify-center mb-2">
                    <FaClock className="w-6 h-6 text-green-600" />
                  </div>
                  <div className="text-sm font-semibold text-green-600 mb-1">
                    {language === 'ar' ? 'وقت التنفيذ' : 'Duration'}
                  </div>
                  <div className="text-xs text-gray-600">
                    {isRTL ? project.stats.duration : project.stats.duration}
                  </div>
                </div>
                <div className="bg-purple-50 rounded-lg p-4 text-center">
                  <div className="flex justify-center mb-2">
                    <FaMapMarkerAlt className="w-6 h-6 text-purple-600" />
                  </div>
                  <div className="text-sm font-semibold text-purple-600 mb-1">
                    {language === 'ar' ? 'المنطقة' : 'Location'}
                  </div>
                  <div className="text-xs text-gray-600">
                    {isRTL ? project.stats.location : project.stats.location}
                  </div>
                </div>
                <div className="bg-orange-50 rounded-lg p-4 text-center">
                  <div className="flex justify-center mb-2">
                    <FaDollarSign className="w-6 h-6 text-orange-600" />
                  </div>
                  <div className="text-sm font-semibold text-orange-600 mb-1">
                    {language === 'ar' ? 'قيمة المشروع' : 'Project Value'}
                  </div>
                  <div className="text-xs text-gray-600">
                    {isRTL ? project.stats.value : project.stats.value}
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg p-6 mb-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">
                  {language === 'ar' ? 'تفاصيل المشروع' : 'Project Details'}
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  {isRTL ? project.detailsAr : project.detailsEn}
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <button
                  onClick={onClose}
                  className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-3 px-6 rounded-lg transition-all duration-300"
                >
                  {language === 'ar' ? 'إغلاق' : 'Close'}
                </button>
                <button
                  className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-300 flex items-center justify-center gap-2"
                >
                  <FaExternalLinkAlt className="w-4 h-4" />
                  {language === 'ar' ? 'عرض المشروع كاملاً' : 'View Full Project'}
                </button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

const ProjectsSection: React.FC<{ language: 'ar' | 'en' }> = ({ language }) => {
  const isRTL = language === 'ar';
  const [selectedProject, setSelectedProject] = useState<typeof projects[0] | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const hoverTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  
  const handleProjectHover = (project: typeof projects[0]) => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
    }
    
    hoverTimeoutRef.current = setTimeout(() => {
      setSelectedProject(project);
      setIsModalOpen(true);
    }, 2000); // 2 seconds
  };

  const handleProjectLeave = () => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = null;
    }
  };

  const handleProjectClick = (project: typeof projects[0]) => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = null;
    }
    setSelectedProject(project);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedProject(null);
  };
  
  return (
    <section className={`section-padding bg-white ${isRTL ? 'font-cairo' : 'font-montserrat'}`} dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="container-custom">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
            className="inline-block px-4 py-2 bg-primary-100 text-primary-700 rounded-full text-sm font-medium mb-4"
          >
            {language === 'ar' ? 'مشاريعنا' : 'Our Projects'}
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            className="text-3xl md:text-4xl font-bold text-gray-900 mb-6"
          >
            {language === 'ar' ? 'مشاريعنا المنجزة' : 'Our Completed Projects'}
            <span className="text-gradient"> {language === 'ar' ? '(شركة مكة البركة للمقاولات والمحاجر)' : '(Mecca El Baraka For Construction & Quarries)'}</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.8 }}
            className="text-lg text-gray-600 max-w-3xl mx-auto mb-8"
          >
            {language === 'ar'
              ? 'نخبة من أبرز المشاريع التي نفذناها في مجالات المقاولات والمحاجر والتعدين، والتي تعكس خبرتنا الواسعة والتزامنا بالجودة والتميز في جميع أعمالنا.'
              : 'A selection of the most prominent projects we have executed in the fields of construction, quarries, and mining, which reflect our extensive experience and commitment to quality and excellence in all our works.'}
          </motion.p>
        </motion.div>

        {/* Projects Slider/Grid */}
        <div className="hidden md:grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {projects.map((project, index) => (
            <motion.div
              key={project.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.8 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
              className="group cursor-pointer"
              onMouseEnter={() => handleProjectHover(project)}
              onMouseLeave={handleProjectLeave}
              onClick={() => handleProjectClick(project)}
            >
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 card-hover flex flex-col h-full border border-gray-100">
                <div className="relative overflow-hidden h-48">
                  <img
                    src={project.images[0]} // Display the first image for the grid view
                    alt={isRTL ? project.titleAr : project.titleEn}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 right-4 bg-white/90 rounded-full p-2 shadow">
                    <project.icon className="w-6 h-6 text-gold-500" />
                  </div>
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-primary-600 transition-colors">
                    {isRTL ? project.titleAr : project.titleEn}
                  </h3>
                  <div className="mt-auto pt-2">
                    <span className="inline-block px-4 py-2 bg-gold-100 text-gold-700 rounded-full text-xs font-semibold">
                      {language === 'ar' ? 'شركة مكة البركة للمقاولات' : 'Mecca El Baraka For Construction'}
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
        
        {/* Mobile Slider */}
        <div className="md:hidden mb-12">
          <Swiper
            modules={[Navigation, Pagination]}
            spaceBetween={24}
            slidesPerView={1}
            pagination={{ clickable: true }}
            navigation={false}
            className="w-full"
          >
            {projects.map((project, index) => (
              <SwiperSlide key={project.id}>
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.1, duration: 0.8 }}
                  viewport={{ once: true }}
                  className="group cursor-pointer"
                  onMouseEnter={() => handleProjectHover(project)}
                  onMouseLeave={handleProjectLeave}
                  onClick={() => handleProjectClick(project)}
                >
                  <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 card-hover flex flex-col h-full border border-gray-100">
                    <div className="relative overflow-hidden h-48">
                      <img
                        src={project.images[0]} // Display the first image for the mobile slider
                        alt={isRTL ? project.titleAr : project.titleEn}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute top-4 right-4 bg-white/90 rounded-full p-2 shadow">
                        <project.icon className="w-6 h-6 text-gold-500" />
                      </div>
                    </div>
                    <div className="p-6 flex-1 flex flex-col">
                      <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-primary-600 transition-colors">
                        {isRTL ? project.titleAr : project.titleEn}
                      </h3>
                      <div className="mt-auto pt-2">
                        <span className="inline-block px-4 py-2 bg-gold-100 text-gold-700 rounded-full text-xs font-semibold">
                          {language === 'ar' ? 'شركة مكة البركة للمقاولات' : 'Mecca El Baraka For Construction'}
                        </span>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      {/* Project Modal */}
      {selectedProject && (
        <ProjectModal
          project={selectedProject}
          isOpen={isModalOpen}
          onClose={closeModal}
          language={language}
        />
      )}
    </section>
  );
};

export default ProjectsSection; 